import * as actionTypes from "../ActionTypes";

// ✅ Save Language Meta
export const saveLanguageMetaRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_LANGUAGE_META_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveLanguageMetaSuccess = (data) => ({
  type: actionTypes.SAVE_LANGUAGE_META_SUCCESS,
  payload: data,
});

export const saveLanguageMetaFailure = (error) => ({
  type: actionTypes.SAVE_LANGUAGE_META_FAILURE,
  payload: error,
});
